<template>
	<ClipLoader :color="color" :size="size" />
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
	name: 'AppLoader',
	components: {
		ClipLoader,
	},
	props: {
		color: { type: String, default: '#5F8FF1' },
		size: { type: String, default: '18px' },
	},
};
</script>

<style scoped lang="scss"></style>
